import { ADD_USER } from "redux/actionTypes/actionTypes";
import { GET_USER } from "redux/actionTypes/actionTypes";
import { DELETE_USER } from "redux/actionTypes/actionTypes";
import { UPDATE_USER } from "redux/actionTypes/actionTypes";
import { GET_USER_LIST } from "redux/actionTypes/actionTypes";
import { SIGN_IN_USER } from "redux/actionTypes/actionTypes";

const initialState = {
  userList: [
    { key: "1", name: "Ali", code: "2105622" },
    { key: "2", name: "Veli", code: "2105622" },
  ],
  currentUser: {},
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case SIGN_IN_USER:
      return {
        ...state,
      };
      break;
    case GET_USER:
      return {
        ...state,
        currentUser: action.payload,
      };
      break;
    case ADD_USER:
      return {
        ...state,
      };
      break;
    case UPDATE_USER:
      return {
        ...state,
      };
      break;
    case DELETE_USER:
      return {
        ...state,
      };
      break;
    case GET_USER_LIST:
      return {
        ...state,
        userList: action.payload,
      };
      break;
    default:
      break;
  }
  return state;
};
export default userReducer;
